import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SubscriptionRequestErrors } from '@/types/subscriptions/request';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import * as asyncActions from './asyncActions';

type State = {
  item: SubscriptionDetail | null;
  warnings: SubscriptionRequestErrors | null;
};

type SharedUpdatePayload = {
  item: State['item'];
  warnings: State['warnings'];
};

const initialState: State = {
  item: null,
  warnings: null,
};

const slice = createSlice({
  name: 'organization-subscription',
  initialState,
  reducers: {
    clearItemAndWarnings(state) {
      state.item = null;
      state.warnings = null;
    },
  },
  extraReducers: (builder) => {
    function sharedClearReducer(state: State) {
      state.item = null;
      state.warnings = null;
    }
    function sharedUpdateReducer(
      state: State,
      action: PayloadAction<SharedUpdatePayload>,
    ) {
      state.item = action.payload.item;
      state.warnings = action.payload.warnings;
    }

    builder
      .addCase(asyncActions.get.fulfilled, (state, action) => {
        state.item = action.payload;
      })
      .addCase(asyncActions.create.fulfilled, sharedUpdateReducer)
      .addCase(asyncActions.update.fulfilled, sharedUpdateReducer)
      .addCase(
        asyncActions.initializeSubscriptionNew.pending,
        sharedClearReducer,
      )
      .addCase(
        asyncActions.initializeSubscriptionEdit.pending,
        sharedClearReducer,
      );
  },
});

export const actions = slice.actions;
export default slice.reducer;
